import { MediumWeightText } from './MediumWeightText';
import { RegularWeightText } from './RegularWeightText';
import { Textbox } from './Textbox';

export const CourseItemNotes = ({ notesArray, gridArea }) => {
	if (!notesArray || !notesArray.length || !notesArray.some(Boolean)) {
		return null;
	}
	return (
		<Textbox background='#EBEFF480' gridArea={gridArea}>
			<MediumWeightText text='Hinweise' size='1.222rem' />
			{notesArray.map((note) => (
				<div key={note}>
					<RegularWeightText text={note} />
				</div>
			))}
		</Textbox>
	);
};